import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=3701c876&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3701c876')) {
      api.createRecord('3701c876', component.options)
    } else {
      api.reload('3701c876', component.options)
    }
    module.hot.accept("./finish.vue?vue&type=template&id=3701c876&", function () {
      api.rerender('3701c876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auditOrder/finish.vue"
export default component.exports